import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "avatar avatar-lg me-3" }
const _hoisted_4 = {
  key: 0,
  class: "fa-solid fa-question d-flex justify-content-center align-items-center avatar-img rounded-circle bg-light text-primary"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "text-subtitle" }

import { computed } from "vue";
import {
  FileBaseUrl,
  type AppointmentChat,
  type AppointmentUser,
  type UserPatient,
} from "@phurshell/psiapp-frontend-core/domain";
import { UserAvatar } from "@/constants/UserAvatar";
import { useChatRoomConfigStore } from "@/store/useChatRoomConfigStore";
import { toggleModal } from "@/utils/Helper";

type ProfileUser = Pick<UserPatient, "name" | "profile_image" | "deleted_at">;
type ProfileChat = Pick<AppointmentChat, "id" | "status" | "created_at">;


export default /*#__PURE__*/_defineComponent({
  __name: 'Profile',
  props: {
    user: {},
    chat: {}
  },
  setup(__props: any) {

const props = __props;

const avatarSrc = computed(() => {
  const img = String(props.user?.profile_image ?? "");
  return UserAvatar[img] ?? `${FileBaseUrl}${img}`;
});

const hasChat = computed(
  () =>
    !!props.chat && props.chat.status === "active" && !props.user.deleted_at,
);

function handleChat() {
  const store = useChatRoomConfigStore();
  const chat_room_config = {
    id: props.chat!.id,
    date: props.chat!.created_at,
    user_name: props.user.name,
    mode: "modal",
  };
  toggleModal("chat_room");
  store.save(chat_room_config);
}

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["d-flex justify-content-between align-items-center", { 'mb-4': hasChat.value }])
      }, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.user.deleted_at)
              ? (_openBlock(), _createElementBlock("i", _hoisted_4))
              : (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: avatarSrc.value,
                  alt: "User Profile Picture",
                  class: "avatar-img rounded-circle"
                }, null, 8, _hoisted_5))
          ]),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.user.deleted_at ? "Paciente removido" : _ctx.user.name), 1)
        ])
      ], 2),
      (hasChat.value)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            label: "Falar com paciente",
            fullWidth: "",
            outline: "",
            onOnClick: handleChat,
            leftIcon: "fa-regular fa-comment-dots"
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})